import { decode } from "base-64";
import { subscriptionService } from "@miplatform/api";
import { bugsnag } from "@miplatform/utils";
import {
  EventType,
  InteractionRequiredAuthError,
  InteractionStatus,
  PublicClientApplication,
} from "@azure/msal-browser";
import { authConfigLocal } from "./authConfig.local";

let authConfigs = null;

export const setAppPermissions = async ({
  msalInstance,
  authScopes,
  inProgress,
  setPermissions,
}) => {
  if (!authConfigs) {
    authConfigs = buildMsalAuthConfig();
  }
  const authRequest = {
    scopes: authScopes,
    account: msalInstance.getActiveAccount(),
    extraQueryParameters: {
      domain_hint: authConfigs.domain.domain_hint,
    },
  };
  let msalResponse;
  try {
    msalResponse = await msalInstance.acquireTokenSilent(authRequest);
  } catch (error) {
    if (
      error instanceof InteractionRequiredAuthError &&
      inProgress === InteractionStatus.None
    ) {
      msalInstance.acquireTokenRedirect(authRequest);
    }
  }
  const [, token] = msalResponse.accessToken.split(".");
  const tokenData = JSON.parse(decode(token));
  const { permissions } = tokenData;

  setPermissions(permissions);
};

export const registerMsalEventCallback = (config) => {
  config.msalInstance.addEventCallback((event) => {
    if (
      [
        EventType.LOGIN_SUCCESS,
        EventType.ACQUIRE_TOKEN_SUCCESS,
        EventType.SSO_SILENT_SUCCESS,
      ].includes(event.eventType) &&
      event.payload.account
    ) {
      config.msalInstance.setActiveAccount(event.payload.account);
    }
  });
};

const getAuthConfig = async () => {
  try {
    if (process.env.NODE_ENV === "development") {
      return authConfigLocal;
    }
    const [domainIdentifier] = window.location.hostname.split(".");
    const config = await subscriptionService.subscriptions.validate(
      domainIdentifier
    );
    if (!config) {
      throw new Error("Empty Auth config");
    }
    return config;
  } catch (error) {
    bugsnag.notify(error);
    return null;
  }
};

export const buildMsalAuthConfig = async () => {
  if (authConfigs) {
    return authConfigs;
  }
  const configs = await getAuthConfig();
  if (!configs) {
    return null;
  }

  const msalConfig = {
    ...configs.msalConfig,
    auth: {
      ...configs.msalConfig.auth,
      authority: configs.domain.signUpSignInAuthority,
    },
  };

  const msalInstance = new PublicClientApplication(msalConfig);
  await msalInstance.initialize();

  authConfigs = {
    ...configs,
    msalConfig,
    loginRequest: {
      scopes: [],
      extraQueryParameters: {
        domain_hint: configs.domain.domain_hint,
      },
    },
    msalInstance,
  };
  return authConfigs;
};
